import * as ActionTypes from 'constants/ActionTypes';
import Immutable from 'immutable';
import merge from 'lodash/object/merge';

let initialState = Immutable.Map();

export default function components(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.DELETE_COMPONENT:
    case ActionTypes.DELETE_ALL_ITEMS:
    case ActionTypes.ADD_COMPONENT:
      return state.setIn(
        [action.component],
        Immutable.fromJS({
          items: {},
          initialized: false,
          totalSize: 0,
        }),
      );

    case ActionTypes.COMPONENT_INITIALIZED:
      return state.setIn([action.component, 'initialized'], true);

    case ActionTypes.SET_COMPONENT_TOTAL_SIZE:
      return state.setIn([action.component, 'totalSize'], action.value);

    case ActionTypes.ADD_ITEM:
      return state.setIn(
        [action.component, 'items', action.item.key],
        Immutable.fromJS(action.item),
      );

    case ActionTypes.ADD_ITEMS:
      return state.mergeIn(
        [action.component, 'items'],
        Immutable.fromJS(action.items),
      );

    case ActionTypes.UPDATE_ITEM:
      return state.updateIn(
        [action.component, 'items', action.item.key],
        item => merge({}, item, action.item),
      );

    case ActionTypes.DELETE_ITEM:
      return state.deleteIn([action.component, 'items', action.item.key]);

    default:
      return state;
  }
}
